export default __webpack_public_path__ + "static/media/wind-turbine.b6230228.svg";